export default __webpack_public_path__ + "static/desktop-af926fb6a8bf32030a916d98e8aa79c9.png";